export { getAuth, signInWithCustomToken, signOut } from 'firebase/auth'
